<div class="row">
    <div class="col-6">
        <jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{'study.details.entry-details.title' | translate}}"
                         iconClass="bms-icon bms-factors" [helpKey]="HELP_MANAGE_STUDIES_GERMPLASM">
            <ng-container *ngIf="entryDetailVariables && entryDetailVariables.length > 0">
                <jhi-variables-table [variables]="entryDetailVariables"
                                     [showInputVariablesColumn]="false"
                                     (onAddEvent)="addVariable($event)"
                                     (onRemoveEvent)="removeVariables($event)"
                                     [variableTypeIds]="[VariableTypeEnum.ENTRY_DETAIL]"
                                     [showReorderButtons]="false"
                                     [preventAddSystemVariables]="studyEditorContext.hasGeneratedDesign()"
                                     [showAddButton]="studyEditorContext.germplasmListExists && principal.hasAnyAuthorityDirect(ADD_ENTRY_DETAILS_VARIABLES_PERMISSIONS)"
                                     [showDeleteButton]="studyEditorContext.germplasmListExists && principal.hasAnyAuthorityDirect(ADD_ENTRY_DETAILS_VARIABLES_PERMISSIONS)"
                ></jhi-variables-table>
            </ng-container>
        </jhi-collapsible>
    </div>
</div>
<div class="row pt-3">
	<div class="col d-flex justify-content-between align-items-center">
		<div>
			<img class="image-icon-sm" src="content/images/review-list-details.png"
				 alt="Review List Details"/>
			<span class="d-inline-flex p-2 h5 fw-bold" jhiTranslate="study-editor.germplasm-checks.study.list">STUDY LIST</span>
			@if (hasDifferences) {
				<span class="fa fa-triangle-exclamation fa-2x ms-2" style="color: #f98424;" ngbTooltip="{{ 'study-editor.germplasm-checks.not.match.germplasm.list' | translate }}"></span>
			}
		</div>
	</div>
</div>
<div class="row pt-3">
	<div class="col d-flex align-items-center">
		@if (!studyEditorContext.germplasmListExists && (!entries || entries.length === 0)) {
			<span jhiTranslate="study-editor.germplasm-checks.browse.list">Browse a list to work with.</span>
			<button class="btn btn-info ms-2" (click)="browseList()" jhiTranslate="study-editor.germplasm-checks.browse.germplasm.list">Browse</button>
		} @else {
			<span jhiTranslate="study-editor.germplasm-checks.germplasm.list"></span>
			@if (listId != null) {
				<span class="ms-2">
					<a [href]="safeUrl" target="_blank">
					<truncate-span [textInput]="listName" [maxLength]="30"></truncate-span>
					</a>
				</span>
			} @else {
				<span class="ms-2 me-2">
					<span jhiTranslate="study-editor.germplasm-checks.germplasm.list.no.available"></span>
				</span>
			}
			@if (!studyEditorContext.hasExperimentalDesign()) {
				<button class="btn btn-primary" (click)="changeList()" jhiTranslate="study-editor.germplasm-checks.replace.germplasm.list">Change</button>
			}
		}
	</div>
</div>
<div class="row pt-3">
    <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <div class="col">
                    <span jhiTranslate="global.total.entries" [translateValues]="{param: numberOfEntries}"></span>
                </div>

            </div>
        </div>
    </div>
</div>
<div class="container-fluid mt-3 ps-0 pe-0">
    <div *ngIf="showStudyEntriesTable">
        <div class="row g-2 g-lg-3">
            <div class="col-12 col-xl-auto d-flex flex-wrap align-items-center gap-2">
                <label class="mb-0 text-nowrap" jhiTranslate="global.records.per.page">Records per page:</label>
                <div class="flex-shrink-0">
                    <select class="form-select form-select-sm"
                            [(ngModel)]="pageSize"
                            (change)="onPageSizeChange($event)">
                        <option value="50">50</option>
                        <option value="75">75</option>
                        <option value="100">100</option>
                    </select>
                </div>

                @if (selectedItems.size > 0) {
                    <jhi-selection-count [selectedItemsSize]="selectedItems.size"
                                         (deselectAction)="clearSelected()"></jhi-selection-count>
                }

                <button class="btn btn-sm btn-outline-info" (click)="clearFilters()">
                    <i class="fa fa-filter-circle-xmark me-1"></i>
                    <span jhiTranslate="study-editor.clear.filter">Clear Filter</span>
                </button>
            </div>
            <div class="col"></div>
            <div class="col-xl-auto ms-xl-auto d-flex flex-wrap align-items-center justify-content-end gap-2">
                <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" id="flexSwitchCategoricalDescriptionView" [(ngModel)]="isCategoricalDescriptionView">
                    <label class="form-check-label text-nowrap" for="flexSwitchCategoricalDescriptionView" jhiTranslate="study-editor.germplasm-checks.show.categorical.desc">Show Categorical Description</label>
                </div>

                @if (entries?.length) {
                    <div ngbDropdown container="body" placement="bottom-right">
                        <button class="btn btn-info btn-sm" id="columnsDropdown" ngbDropdownToggle>
                            <span jhiTranslate="study-editor.actions">Actions</span>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="columnsDropdown">
                            <button *ngIf="showReplaceGermplasmAction()" class="dropdown-item" type="submit"
                                    (click)="replaceGermplasm()" jhiTranslate="study-editor.germplasm-checks.action.replace-germplasm">Replace Germplasm
                            </button>
                            <button *ngIf="showAddNewEntriesAction()" class="dropdown-item" type="submit"
                                    (click)="addNewEntries()" jhiTranslate="study-editor.germplasm-checks.action.add-entries">Add New Entries
                            </button>
                            <button *ngIf="showImportEntryDetailsAction()" class="dropdown-item" type="submit"
                                    (click)="importEntryDetails()"><span jhiTranslate="study-editor.germplasm-checks.action.import-entry-details">Import Entry Details</span>
                            </button>
                            <button *ngIf="showSetEntryTypeAction()" class="dropdown-item" type="submit"
                                    (click)="setEntryType()"><span jhiTranslate="study-editor.germplasm-checks.action.set-entry-type">Set Entry Type</span>
                            </button>
                        </div>
                    </div>
                }

                @if (entries?.length && hasAnyAuthority(MODIFY_COLUMNS_PERMISSIONS)) {
                    <jhi-column-selector [disabled]="isLoading"
                                         [displayedColumns]="displayedColumns"
                                         [columnDataService]="columnDataService"
                                         (reset)="onColumnSelectorReset()"
                                         (changed)="onColumnSelectoChange($event)"></jhi-column-selector>
                }
            </div>
        </div>
        <!-- Data Table -->
        <div class="table-responsive mt-3">
            <div class="custom-scroll-style" style="min-height:500px; max-height: 500px; overflow-y: auto; overflow-x: auto;">
                <table id="germplasm-checks-table"
                       class="table table-striped table-bordered table-curved table-editable">
                    <thead class="sticky-header">
                    <tr cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="dropColumn($event)">
                        @for (column of displayedColumns; track trackColumnsById(column)) {
                            @if (column.selected && column.visible) {
                                <th cdkDrag cdkDragHandle [ngClass]="getColumnClass(column)">

                                    @if (getStaticColumnLabelKey(column.termId)) {
                                        {{ getStaticColumnLabelKey(column.termId) | translate }}
                                    } @else {
                                        {{ column.displayName }}
                                    }

                                    @if (column.termId === STATIC_COLUMN_CHECKBOX) {
                                        <input type="checkbox" class="form-check-input m-1"
                                               [ngbTooltip]="'global.select.current.page' | translate"
                                               [checked]="isPageSelected()"
                                               (click)="onSelectPage()">
                                    }

                                    @if (column.termId === STATIC_COLUMN_CROSS && !studyEditorContext?.studyDetails?.locked) {
                                        <span class="cursor-pointer ms-2"
                                              #cePopover="ngbPopover"
                                              (click)="showCrossExpansionPopover(cePopover)"
                                              [autoClose]="'outside'"
                                              [ngbPopover]="crossExpansion"
                                              container="body"
                                              [placement]="['bottom', 'right', 'auto']"
                                              triggers="manual">
                                        <i class="fa fa-edit"></i>
                                    </span>
                                    }

                                    @if (column.termId !== STATIC_COLUMN_CHECKBOX) {
                                        <span class="cursor-pointer ms-1"
                                              #p="ngbPopover"
                                              (click)="showColumnFilterPopover(column, p)"
                                              [autoClose]="'outside'"
                                              [ngbPopover]="columnFilterTemplate"
                                              container="body"
                                              [placement]="['bottom', 'right', 'auto']"
                                              triggers="manual">
                                    <i class="fa fa-filter ps-1" [ngClass]="{'filtering-by': column.isFiltered}"></i>
                                            @if (column.sortingAsc !== undefined && column.sortingAsc !== null) {
                                                <i class="ps-1 fa fa-icon-active"
                                                   [ngClass]="{'fa-sort-asc': column.sortingAsc, 'fa-sort-desc': !column.sortingAsc}">
                                        </i>
                                            }
                                </span>
                                    }
                                </th>
                            }

                        }
                    </tr>
                    </thead>
                    <tbody>
                        @if (entries.length !== 0) {
                            @for (entry of entries; track trackRowsById(entry); let row = $index) {
                                <tr
                                    (click)="toggleSelect($event, row, entry); $event.stopPropagation()"
                                    [class.selected]="isSelected(entry.entryId)"
                                    (mousedown)="preventDefaultOnShiftKey($event)"
                                    (contextmenu)="handleContextMenu($event)">
                                    @for (column of displayedColumns; track trackColumnsById(column); let col = $index) {
                                        <td *ngIf="column.selected && column.visible"
                                            (click)="selectEditableCell(entry, column, row, col, $event)"
                                            [class.selected]="editingCell?.row === row && editingCell?.col === col && isColumnEditable(column)"
                                            [class.number-cell]="variableDataTypeIs(column, DataTypeEnum.NUMERIC)"
                                            [class.date-cell]="variableDataTypeIs(column, DataTypeEnum.DATE)"
                                            [class.categorical-cell]="variableDataTypeIs(column, DataTypeEnum.CATEGORICAL)"
                                            [class.error-cell]="getCellData(row, col)?.hasError"
                                            [attr.data-test]="'germplasm-entries-table-cell-' + column.termId"
                                            [ngClass]="getCellClass(entry, column)">

                                            @switch (true) {
                                                @case (column.termId === STATIC_COLUMN_CHECKBOX) {
                                                    <input type="checkbox" class="form-check-input m-1"
                                                           [checked]="isSelected(entry.entryId)"
                                                           (change)="toggleSelect($event, row, entry, true)"
                                                           (click)="$event.stopPropagation()"/>
                                                }
                                                @case (STATIC_COLUMN_ACTIVE_LOT === column.termId) {
                                                    @if (entry.lotCount) {
                                                        <a href="javascript:void(0)" class="link" (click)="openInventoryDetails(entry.gid)">
                                                            {{ entry.lotCount }}
                                                        </a>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_AVAILABLE === column.termId) {
                                                    @if (entry.availableBalance) {
                                                        {{ entry.availableBalance }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_UNIT === column.termId) {
                                                    @if (entry.unit) {
                                                        {{ entry.unit }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_CROSS === column.termId) {
                                                    @if (entry.cross) {
                                                        <truncate-span [textInput]="entry.cross" [maxLength]="MAX_NAME_DISPLAY_SIZE" [minWidth]="'280px'"></truncate-span>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_GROUPGID === column.termId) {
                                                    @if (entry.groupGid) {
                                                        <a  href="javascript:void(0)" (click)="openGermplasmDetails(entry.groupGid)">
                                                            <truncate-span [textInput]="entry.groupGid"></truncate-span>
                                                        </a>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (editingCell?.row === row && editingCell?.col === col && isColumnEditable(column)) {
                                                    <jhi-study-inline-editor
                                                            categoricalBindBy="name"
                                                            [observationVariable]="column"
                                                            [cellData]="getCellData(row, col)"
                                                            (onBlur)="onCellBlur(column, row, col)"
                                                            (onKeyDown)="onCellKeyDown($event, column, row, col)"
                                                            [categoricalDropdownPosition]="row <= 4 ? 'bottom' : 'auto'">
                                                    </jhi-study-inline-editor>
                                                }
                                                @default {
                                                    @if (entry.properties[column.termId]) {
                                                        @if ([STATIC_COLUMN_GID, STATIC_COLUMN_DESIGNATION].includes(column.termId)) {
                                                            @if (hasViewGermplasmDetailsPermission) {
                                                                <a class="link" (click)="germplasmDetailsPopupService.open(entry.gid)">
                                                                    <truncate-span [textInput]="getCellValue(entry, column) | categoricalDisplayValue:column:'name':isCategoricalDescriptionView" [maxLength]="MAX_NAME_DISPLAY_SIZE" [minWidth]="'280px'"></truncate-span>
                                                                </a>
                                                            } @else {
                                                                <truncate-span [textInput]="getCellValue(entry, column) | categoricalDisplayValue:column:'name':isCategoricalDescriptionView" [maxLength]="MAX_NAME_DISPLAY_SIZE" [minWidth]="'280px'"></truncate-span>
                                                            }
                                                        } @else if ([STATIC_COLUMN_MALE_PARENT_GID, STATIC_COLUMN_MALE_PARENT_NAME].includes(column.termId)) {
                                                            @if (STATIC_COLUMN_MALE_PARENT_GID === column.termId && entry.properties[STATIC_COLUMN_MALE_PARENT_GID]?.values) {
                                                                <jhi-expandable-cell [data]="entry.properties[STATIC_COLUMN_MALE_PARENT_GID]?.values"
                                                                                     [asLink]="hasViewGermplasmDetailsPermission"
                                                                                     (itemClick)="germplasmDetailsPopupService.open(entry.properties[STATIC_COLUMN_MALE_PARENT_GID]?.values[$event])" ></jhi-expandable-cell>
                                                            }
                                                            @if (STATIC_COLUMN_MALE_PARENT_NAME === column.termId && entry.properties[STATIC_COLUMN_MALE_PARENT_NAME]?.values) {
                                                                <jhi-expandable-cell [data]="entry.properties[STATIC_COLUMN_MALE_PARENT_NAME]?.values"
                                                                                     [asLink]="hasViewGermplasmDetailsPermission"
                                                                                     (itemClick)="germplasmDetailsPopupService.open(entry.properties[STATIC_COLUMN_MALE_PARENT_GID]?.values[$event])" ></jhi-expandable-cell>
                                                            }
                                                        } @else if ([STATIC_COLUMN_FEMALE_PARENT_GID, STATIC_COLUMN_FEMALE_PARENT_NAME].includes(column.termId)) {
                                                            @if (STATIC_COLUMN_FEMALE_PARENT_GID === column.termId && entry.properties[STATIC_COLUMN_FEMALE_PARENT_GID]?.values) {
                                                                <jhi-expandable-cell [data]="entry.properties[STATIC_COLUMN_FEMALE_PARENT_GID]?.values"
                                                                                     [asLink]="hasViewGermplasmDetailsPermission"
                                                                                     (itemClick)="germplasmDetailsPopupService.open(entry.properties[STATIC_COLUMN_FEMALE_PARENT_GID]?.values[$event])" ></jhi-expandable-cell>
                                                            }
                                                            @if (STATIC_COLUMN_FEMALE_PARENT_NAME === column.termId && entry.properties[STATIC_COLUMN_FEMALE_PARENT_NAME]?.values) {
                                                                <jhi-expandable-cell [data]="entry.properties[STATIC_COLUMN_FEMALE_PARENT_NAME]?.values"
                                                                                     [asLink]="hasViewGermplasmDetailsPermission"
                                                                                     (itemClick)="germplasmDetailsPopupService.open(entry.properties[STATIC_COLUMN_FEMALE_PARENT_GID]?.values[$event])" ></jhi-expandable-cell>
                                                            }
                                                        } @else if ([STATIC_COLUMN_BREEDING_METHOD_ABBR].includes(column.termId)) {
                                                            <a (click)="$event.stopPropagation()"
                                                               [routerLink]="['/', { outlets: { popup: 'breeding-method-by-code/' + entry.properties[STATIC_COLUMN_BREEDING_METHOD_ABBR]?.value } }]"
                                                               [queryParams]="this.paramContext.toQueryParams()">
                                                                {{ getCellValue(entry, column) | categoricalDisplayValue:column:'name':isCategoricalDescriptionView }}
                                                            </a>
                                                        } @else {
                                                            <truncate-span [textInput]="getCellValue(entry, column) | categoricalDisplayValue:column:'name':isCategoricalDescriptionView" [maxLength]="MAX_NAME_DISPLAY_SIZE" [minWidth]="'280px'"></truncate-span>
                                                        }
                                                    }
                                                }
                                            }
                                        </td>
                                    }
                                </tr>
                            }
                        } @else {
                            <tr>
                                <td [attr.colspan]="displayedColumns.length" class="text-center py-3">
                                    {{ 'study-editor.no-records' | translate }}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mt-3">

            <div>
				@if (numberOfEntries !== numberOfFilteredEntries) {
					<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
						  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredEntries), param3: numberOfFilteredEntries}"></span>
					<span class="text-muted" jhiTranslate="study-editor.pagination.entry-total-count" [translateValues]="{param: numberOfEntries}"></span>
				} @else {
					<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
						  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredEntries), param3: numberOfEntries}"></span>
				}
            </div>

            <div>
                <div class="d-inline-block ms-3">
                        <ngb-pagination
                                [collectionSize]="numberOfFilteredEntries || numberOfEntries"
                                [(page)]="currentPage"
                                [pageSize]="pageSize"
                                [maxSize]="10"
                                [ellipses]="true"
                                [boundaryLinks]="true"
                                [rotate]="true"
                                (pageChange)="onPageChange($event)">
                        </ngb-pagination>
                    </div>
                    <div class="d-inline-block ms-3">
                        <label for="goToPage" class="me-2" jhiTranslate="study-editor.pagination.go-to">Go to page:</label>
                        <input id="goToPage" type="number" class="form-control d-inline-block w-auto"
                               [min]="1" [max]="Math.ceil((numberOfFilteredEntries || numberOfEntries) / pageSize)"
                               [(ngModel)]="currentPage"
                               (change)="onPageChange(currentPage); $event.preventDefault()"/>
                    </div>
                <!-- Clear List Button -->
                <div class="d-inline-block ms-3" *ngIf="showClearList">
                    <button class="btn btn-primary" (click)="resetStudyEntries()" jhiTranslate="study-editor.germplasm-checks.clear.list">
                        Clear List
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #crossExpansion>
    <div class="cross-expansion-container">
        <div class="row">
            <div class="col d-flex align-items-center">
                <label class="fw-bold" for="crossExpansionSelect" jhiTranslate="study-editor.germplasm-checks.expansion-level">Specify Expansion Level:</label>
                <select class="form-select w-40 ms-2" name="crossExpansionSelect" #crossExpansionSelect>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                </select>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col d-flex justify-content-center">
                <button class="btn btn-info ms-2" (click)="fillWithCrossExpansion(crossExpansionSelect.value)" jhiTranslate="apply">
                    Apply
                </button>
            </div>
        </div>
    </div>

</ng-template>

<!-- Column Filter Template -->
<ng-template #columnFilterTemplate>
    <div class="column-filter">
        <!-- Sorting Buttons -->
        <div class="btn-group w-100" role="group" *ngIf="columnDataForFilter.enableFilterSorting !== false">
            <button (click)="sortColumn(columnDataForFilter,true)" class="btn btn-o"
                    [ngClass]="columnDataForFilter.sortingAsc === true ? 'btn-info' : 'btn-outline-secondary'">
                <i class="fa fa-sort-alpha-asc fw-bold fs-6"></i>
            </button>
            <button (click)="sortColumn(columnDataForFilter,false)" class="btn"
                    [ngClass]="columnDataForFilter.sortingAsc === false ? 'btn-info' : 'btn-outline-secondary'">
                <i class="fa fa-sort-alpha-desc fw-bold fs-6"></i>
            </button>
        </div>
        <!-- Regular Input Filter -->
        <div *ngIf="columnDataForFilter.dataTypeCode !== 'D'" class="mt-2">
            <input class="form-control"
                   [(ngModel)]="columnDataForFilter.query"
                   placeholder="{{ 'common.filter.value' | translate }}"
                   [title]="columnDataForFilter.possibleValues?.length ? ('study-editor.study-dataset.no.values.filter.title' | translate) : ''">

            <!-- Filter Options List -->
            <ul class="list-group mt-3" *ngIf="columnDataForFilter.possibleValues">
                <li class="list-group-item" *ngIf="!columnDataForFilter.query">
                    <div class="form-check">
                        <input type="checkbox"
                               class="form-check-input"
                               [(ngModel)]="columnDataForFilter.isSelectAll"
                               (change)="filterSelectAll(columnDataForFilter, columnDataForFilter.isSelectAll)">
                        <label class="form-check-label"jhiTranslate="global.select.all.items">Select all</label>
                    </div>
                </li>
                <li *ngFor="let option of columnDataForFilter.possibleValues | orderBy:'name' | filter:columnDataForFilter.query:'name'"
                    class="list-group-item">
                    <div class="form-check">
                        <input type="checkbox"
                               class="form-check-input"
                               [(ngModel)]="option.isSelectedInFilters"
                               (change)="filterSelectOption(option.isSelectedInFilters)">
                        <label class="form-check-label">
                            {{ isCategoricalDescriptionView ? option.displayDescription : option.displayValue }}
                        </label>
                    </div>
                </li>
            </ul>
        </div>

        <!-- Date Filter -->
        <div *ngIf="columnDataForFilter.dataTypeCode === 'D'" class="mt-3">
            <input class="form-control"
                   [(ngModel)]="columnDataForFilter.query"
                   ngbDatepicker="dp"
                   placeholder="{{ 'common.filter.value' | translate }}">
            <div class="mt-3">
                <ngb-datepicker #dp
                                [(ngModel)]="columnDataForFilter.query"
                                class="well well-sm"
                                (click)="$event.stopPropagation()">
                </ngb-datepicker>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="mt-3">
            <div class="d-flex justify-content-around">
                <div>
                    <button class="btn btn-info ms-2"
                            (click)="filterByColumn(columnDataForFilter)"
                            title="{{ 'global.apply.all.filter' | translate }}" jhiTranslate="apply">
                        Apply
                    </button>
                    <button class="btn btn-secondary ms-2"
                            (click)="resetFilterByColumn(columnDataForFilter)"
                            title="{{ 'global.reset.filter' | translate }}" jhiTranslate="reset">
                        Reset
                    </button>
                </div>
            </div>
        </div>
    </div>

</ng-template>
